import styled from "styled-components"

import {Para} from "@irati/ui/src/Labels"

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Image = styled.img`
  height: 100px;
  width: 100px;
  margin-right: 20px;
`

export const StyledPara = styled(Para)`
  margin-top: 10px;
`
